import { getLengthValue } from '../../../system';
export const withMargins = ({ theme, ...props }) => {
    const rules = {};
    if (props.margin !== undefined) {
        rules.margin = getLengthValue({ length: props.margin, theme });
    }
    if (props.marginX !== undefined) {
        rules.marginLeft = getLengthValue({ length: props.marginX, theme });
        rules.marginRight = getLengthValue({ length: props.marginX, theme });
    }
    if (props.marginY !== undefined) {
        rules.marginTop = getLengthValue({ length: props.marginY, theme });
        rules.marginBottom = getLengthValue({ length: props.marginY, theme });
    }
    if (props.marginLeft !== undefined) {
        rules.marginLeft = getLengthValue({ length: props.marginLeft, theme });
    }
    if (props.marginRight !== undefined) {
        rules.marginRight = getLengthValue({ length: props.marginRight, theme });
    }
    if (props.marginTop !== undefined) {
        rules.marginTop = getLengthValue({ length: props.marginTop, theme });
    }
    if (props.marginBottom !== undefined) {
        rules.marginBottom = getLengthValue({ length: props.marginBottom, theme });
    }
    return rules;
};
